import { lazy } from 'react';
import { Bike } from 'lucide-react';
import type { FeatureRoute, FeatureSection } from '@/app/registry';
import { fieldopsRoutes } from '@/features/fieldops/section';

/**
 * Rides: listed in the Customers menu (support looks rides up by the customer); the
 * /operations/rides paths stay so links and bookmarks keep working.
 */
export const rideRoutes: FeatureRoute[] = [
  {
    path: '/operations/rides',
    title: 'rides',
    tabs: [
      { key: 'rides', title: 'rides', resource: 'ride', component: lazy(() => import('./rides/RidesPage')) },
      { key: 'ratings', title: 'ratings', resource: 'ride', legacyPath: '/operations/ride-ratings', component: lazy(() => import('./ratings/RideRatingsPage')) },
    ],
  },
  { path: '/operations/rides/:rideId', title: 'ride', resource: 'ride', hideInMenu: true, component: lazy(() => import('./rides/RideDetailPage')) },
];

/** Operations: what is happening on the street now: the command center, the fleet, and the
 * field work (tickets and technicians, formerly their own "Field operations" menu). */
export const operationsSection: FeatureSection = {
  key: 'operations',
  title: 'operations',
  icon: Bike,
  routes: [
    {
      path: '/operations/command-center',
      title: 'commandCenter',
      resource: 'command_center',
      legacyPath: '/fieldops/command-center',
      component: lazy(() => import('@/features/fieldops/command-center/CommandCenterPage')),
    },
    {
      path: '/operations/vehicles',
      title: 'fleet',
      tabs: [
        { key: 'shared', title: 'sharedFleet', resource: 'vehicle', component: lazy(() => import('./vehicles/VehiclesPage')) },
        { key: 'map', title: 'fleetMap', resource: 'vehicle', component: lazy(() => import('./fleet-map/FleetMapPage')) },
        {
          key: 'private',
          title: 'privateVehicles',
          resource: 'vehicle.private',
          legacyPath: '/operations/private-vehicles',
          component: lazy(() => import('./private-vehicles/PrivateVehiclesPage')),
        },
      ],
    },
    { path: '/operations/vehicles/number/:number', title: 'vehicle', resource: 'vehicle', hideInMenu: true, component: lazy(() => import('./vehicles/VehicleByNumberPage')) },
    { path: '/operations/vehicles/:vehicleId', title: 'vehicle', resource: 'vehicle', hideInMenu: true, component: lazy(() => import('./vehicles/VehicleDetailPage')) },
    ...fieldopsRoutes,
  ],
};
